/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule } from '@angular/core';

import { ElSharedModule } from '../shared/shared.module';
import { ElIconModule } from '../icon/icon.module';
import { ElCheckboxComponent } from './checkbox.component';

@NgModule({
  imports: [
    ElSharedModule,
    ElIconModule,
  ],
  declarations: [ElCheckboxComponent],
  exports: [ElCheckboxComponent],
})
export class ElCheckboxModule { }
